export const setLocalData = async (key: string, value: any) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      // saving error
    }
  };
  export const getLocalData = (key: string) => {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      console.error("Error reading from localStorage", e);
      return null;
    }
  };
  export const removeLocalData = async (key:string) => {
    try {
      return await localStorage.removeItem(key);
    } catch (e) {
      // error reading value
    }
  };

 